export default __webpack_public_path__ + "static/media/mail-send.bf9188d3.svg";